var _path, _rect, _path2, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.875V18.125H16.25V6L16.0625 5.8125L12.3125 2.0625L12.125 1.875H3.75ZM5 3.125H11.25V6.875H15V16.875H5V3.125ZM12.5 4L14.125 5.625H12.5V4ZM6.875 8.125L9.25 11.5625L6.875 15H8.375L10 12.625L11.625 15H13.125L10.75 11.5625L13.125 8.125H11.625L10 10.5L8.375 8.125H6.875Z",
    fill: "#20A74E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 11.25,
    width: 3.75,
    height: 7.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.8936L17.5 16.8936L17.5195 12.4999L16.8945 12.4999L16.2695 12.4999L16.2438 16.8936L13.75 16.8936L16.875 20.0186L20 16.8936Z",
    fill: "#20A74E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9746,
    y: 15.9492,
    width: 1.23114,
    height: 3.76384,
    transform: "rotate(-45 10.9746 15.9492)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.25L13.75 16.25L13.75 17.5L12.5 16.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExcel);
export default __webpack_public_path__ + "static/media/download_excel.08425a2e786d13d1259886c4471b4ad6.svg";
export { ForwardRef as ReactComponent };